/* import __COLOCATED_TEMPLATE__ from './add-credit-modal.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { COMPANY_PROFILE_COMPONENT } from 'sh-www/components/company-profile/company-profile';
import { makeMoney } from 'sh-www/helpers/make-money';
import { showNextModal, closeModal } from 'sh-www/utils/modal-controls';
import { LSG_DIALOG_HEIGHT_TYPE } from 'sh-www/components/lsg/lsg-dialog';

const CLASS_NAME = 'SH-c-reports-add-credit-modal';

const INLINE_ERRORS = [
  'generic-exception',
  'amount_in_cents',
  'cost_code_id',
  'memo',
];

class ReportsAddCreditModal extends Component {
  @service constants;
  @service session;

  @tracked errors = {};
  @tracked paymentAmount = null;
  @tracked destinationCostCode = null;
  @tracked memo = null;
  @tracked showMemo = false;

  get className() {
    return CLASS_NAME;
  }

  get inlineErrors() {
    return INLINE_ERRORS;
  }

  get destinationCostCodeValue() {
    return this.destinationCostCode?.body;
  }

  get costCodesSectionEnum() {
    return COMPANY_PROFILE_COMPONENT.SECTIONS.CODES;
  }

  get modalHeightType() {
    return this.showMemo
      ? LSG_DIALOG_HEIGHT_TYPE.HEIGHT_MAX_400_PX
      : LSG_DIALOG_HEIGHT_TYPE.HEIGHT_300_px;
  }

  get submitDisabled() {
    return !this.destinationCostCode
      || (
        !this.paymentAmount
        || Number.parseFloat(this.paymentAmount) <= 0
      );
  }

  @action
  handleDestinationCostCodeSelected(costCode) {
    this.destinationCostCode = costCode;
  }

  @action
  handleShowMemo(showMemo) {
    this.showMemo = showMemo;
  }

  @action
  handleMemoInput(value) {
    this.memo = value;
  }

  @action
  handlePaymentAmountInput(amount) {
    this.paymentAmount = amount;
  }

  @action
  handlePaymentAmountBlur() {
    const { paymentAmount } = this;
    const paymentAmountFloat = Number.parseFloat(paymentAmount);

    // clear bad input
    if (!Number.isFinite(paymentAmountFloat) || paymentAmountFloat <= 0) {
      this.paymentAmount = '';
    } else {
      this.paymentAmount = makeMoney([paymentAmount], { commas: false }).replace('$', '');
    }
  }

  @action
  handleDismiss() {
    closeModal(this);
  }

  @action
  handleSubmit() {
    const {
      destinationCostCode,
      memo,
      paymentAmount,
    } = this;

    const {
      company,
      loadCompanyCostCodeCreditsTask,
      loadCreditUnpaidInvoicesTask,
      loadCompanyCreditFactoidsTask,
      updateCompanyCostCodeCredits,
      updateCompanyCreditFactoids,
      updateShGeneralUnpaidInvoices,
    } = this.args.model;

    // show confirm
    showNextModal(this, 'reports/add-credit-modal-confirm', {
      company,
      destinationCostCode,
      memo,
      paymentAmount,
      loadCompanyCostCodeCreditsTask,
      loadCreditUnpaidInvoicesTask,
      loadCompanyCreditFactoidsTask,
      updateCompanyCostCodeCredits,
      updateCompanyCreditFactoids,
      updateShGeneralUnpaidInvoices,
    });
  }
}

export default ReportsAddCreditModal;
